import useDashboardStore from "./store";

export default useDashboardStore;
